import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginFinances } from '../services/api';
import Footer from '../components/Footer';
import './LoginAdmin.css';

const LoginFinances = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await loginFinances(username, password);
      
      localStorage.setItem('finances_token', response.data.token);
      localStorage.setItem('finances_user', JSON.stringify(response.data.admin));
      navigate('/finances');
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-container">
        <div className="login-box">
          <div className="logo-container">
            <img src="/logo.png" alt="MUTU NDE ESPOIR ASBL" className="logo" />
          </div>
          <h2>MUTU NDE ESPOIR ASBL</h2>
          <h3>Interface Finances</h3>
          <form onSubmit={handleSubmit}>
            {error && <div className="alert alert-error">{error}</div>}
            
            <div className="form-group">
              <label>Nom d'utilisateur</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>Mot de passe</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary" 
              style={{ width: '100%' }}
              disabled={loading}
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LoginFinances;
